import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {MenusLinksLists} from '../menus-links-list.js';

import {quickNavigationsFactory} from './factory.js';

import PALETTE_SCHEMA from './quick-navigations.palette-schema.yaml';

class QuickNavigationsFeature extends AbstractVisualFeature {
    get name() {
        return 'QuickNavigations';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return quickNavigationsFactory(PALETTE);
    }
}

new QuickNavigationsFeature(MenusLinksLists);
